import { stringify } from 'query-string';
import { isNullOrUndefinedOrEmpty } from './common';
/**
 * urlの項目からjsonを安全に取り出す関数
 * @param v
 * @returns {Array}
 */
export const safeJsonParse = (v) => {
    let result = [];
    try {
        const params = JSON.parse(v);
        if (Array.isArray(params)) {
            result = params.filter((str) => typeof str === 'string' || typeof str === 'number');
        }
    }
    catch (_) {
        result = [];
    }
    return result;
};
/**
 * query stringの分割の実行
 * @param v
 * @param separator
 * @returns {string[]}
 */
export const getSplitQuery = (v, separator = ',') => (typeof v === 'string' ? v : '').split(separator).filter((parts) => parts);
/**
 * パラメータのオブジェクトのvalueのうち、一つでも値が設定されているか
 * @param params
 * @returns {boolean}
 */
export const hasParamValues = (params = {}) => Object.values(params).some((v) => {
    if (isNullOrUndefinedOrEmpty(v)) {
        return false;
    }
    if (Array.isArray(v)) {
        return v.length > 0;
    }
    if (typeof v === 'object') {
        return hasParamValues(v);
    }
    if (typeof v === 'boolean' || Number.isNaN(v)) {
        return true;
    }
    return !!v;
});
/**
 * 有効なパラメータであればURLに付与、それ以外であればURLだけ返す関数
 * @param path
 * @param params
 * @returns {string}
 */
export const stringifyWithPath = (path, params = {}) => hasParamValues(params) ? `${path}?${stringify(params)}` : path;
